import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { VITE_BACKEND_URL } from "@/api/config";
import { NavigateFunction } from "react-router-dom";

const NO_REDIRECT_ENDPOINTS = ["/api/login"];

export async function safeAxios(
  endpoint: string,
  navigate?: NavigateFunction,
  options?: AxiosRequestConfig
): Promise<AxiosResponse> {
  try {
    const res = await axios({
      url: `${VITE_BACKEND_URL}${endpoint}`,
      ...options,
    });

    return res;

  } catch (err: any) {
    console.error("❌ Error en safeAxios:", err);

    // 🔹 Login u otras rutas sin redirección
    if (NO_REDIRECT_ENDPOINTS.some(e => endpoint.includes(e))) {
      throw err;
    }

    // 🔹 Si no hay navigate, solo propaga error
    if (!navigate) {
      throw err;
    }

    // 🔹 Offline
    if (!navigator.onLine) {
      navigate("/offline");
    }
    // 🔹 Error backend
    else if (err.response) {
      navigate("/errorPage");
    }

    throw err;
  }
}
